import { render, staticRenderFns } from "./ButtonImg.vue?vue&type=template&id=d8cfabb6&scoped=true&"
import script from "./ButtonImg.vue?vue&type=script&lang=js&"
export * from "./ButtonImg.vue?vue&type=script&lang=js&"
import style0 from "./ButtonImg.vue?vue&type=style&index=0&id=d8cfabb6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8cfabb6",
  null
  
)

export default component.exports